import axios from 'axios';
import Config from '../../../config';

const axiosInstance = axios.create({
  baseURL: `${Config.develURL}`,
  crossDomain: true,
  headers: { 'Content-Type': 'application/json', 'Accept-Language': 'CS' }
});

export default axiosInstance;
